var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-iar-submit-tips-portrait"},[_c('div',{staticClass:"plv-iar-submit-tips-portrait__main",style:(_vm.hintStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }